import { chat ,SupportTicket} from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  uploadFile(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(chat.chatAttachment, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getSupportIntegrationUrl(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(SupportTicket.SupportTicketBase, {})
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
})
